"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceBucketService = void 0;
class PriceBucketService {
    constructor() {
        this.myValue = { min: 0, max: 0 };
        this.loginURL = '/login';
    }
    pull() {
        this.myValue.min = 0.01;
        this.myValue.max = 99;
        this.defaultArray = [
            {
                tier: .1,
                pbi: .1,
                min: '',
                value: ''
            },
            {
                tier: 5,
                pbi: .5,
                min: '',
                value: ''
            },
            {
                tier: 10,
                pbi: 5,
                min: '',
                value: ''
            },
            {
                tier: 20,
                pbi: 10,
                min: '',
                value: ''
            },
            {
                tier: 30,
                pbi: 30,
                min: '',
                value: ''
            }
        ];
    }
    getMin() {
        return this.myValue.min;
    }
    getMax() {
        return this.myValue.max;
    }
    getDefault() {
        return JSON.parse(JSON.stringify(this.defaultArray));
    }
}
exports.PriceBucketService = PriceBucketService;
//# sourceMappingURL=price-bucket.service.js.map